(function () {

  $(function() {
    const atelierTopSwiper = new Swiper(".js-atelierTopSlider", {
      loop: true,
      navigation: {
        nextEl: '.p-atelierGallerySliderNav--next',
        prevEl: '.p-atelierGallerySliderNav--prev',
      },
      on: {
        imagesReady: function () {
          $(".js-atelierTopSlider").css('height', 'auto');
        },
      },
      autoplay: {
        delay: 3000,
      },
    });

    const ringsSwiper = new Swiper(".js-ringsSwiper", {
      slidesPerView: "auto",
      spaceBetween: 3,
      breakpoints: {
        900: {
          spaceBetween: 32,
        }
      }
    });
  });

})();
